import { array, string } from 'yup';
import { getNote } from '../helper-functions/getNote';
import { NOTE_TYPE } from '../../constants/appConstants';
import { CLIENT_MESSAGE_LENGTH } from '../../constants/Helpers';
import { nullToArray } from './transforms';

export const treatmentRecordCommonSchema = {
  topLevel: {
    note: array().test(
      'clientMessage',
      `Client message must be at least ${CLIENT_MESSAGE_LENGTH.toString()} characters.`,
      (value) => {
        const noteForCustomerText =
          getNote(NOTE_TYPE.noteForCustomer, value)?.text ?? '';
        return Boolean(
          noteForCustomerText &&
            noteForCustomerText.length >= CLIENT_MESSAGE_LENGTH,
        );
      },
    ),
    recommendedProduct: array()
      .required('Product Recommendations')
      .min(1, 'Product Recommendations')
      .nullable(true)
      .transform(nullToArray),
  },
  treatmentAttributes: {
    skinType: string().required('Skin Type').nullable(true),
    conditions: array(string())
      .required('Conditions')
      .min(1, 'Conditions')
      .nullable(true),
    topTreatmentFocus: array(string())
      .required('Top Treatment Focus')
      .min(1, 'Top Treatment Focus')
      .max(3, 'Top Treatment Focus')
      .nullable(true)
      .transform(nullToArray),
    openingRitualAromatherapy: array(string())
      .required('Opening Ritual Aromatherapy')
      .min(1, 'Opening Ritual Aromatherapy')
      .nullable(true)
      .transform(nullToArray),
  },
};
